import axios from "axios";

import {
  HANDBOOK_EXPENDITURE_APPROVAL_STATUS,
  ICreateTemplateExpenditure,
  ICreateTemplateSection,
  IGetTemplateSectionsListFilter,
  IHandBook,
  IHandBookAggregate,
  IHandBookExpenditureApproval,
  IHandBookRequest,
  IHandBookSegment,
  IHandBookTemplate,
  IHandBookTemplateExpenditure,
} from "./types";
import { IListResponseData } from "types/ListResponse";
import getLongList from "utils/axios/loadLongList";

export const handBookApi = {
  getAggregate: () => {
    return axios.get<IHandBookAggregate>(`/help/manual_expenditures/aggregate/`);
  },
  getList: (
    filter: IHandBookRequest = { status: HANDBOOK_EXPENDITURE_APPROVAL_STATUS.APPROVED },
    controller?: AbortController
  ) => {
    const params = new URLSearchParams();
    Object.entries(filter).forEach(([key, value]) => {
      if (Array.isArray(value)) {
        value.forEach((e) => params.append(key, e));
      } else {
        params.append(key, value);
      }
    });
    return axios.get<IListResponseData<IHandBook>>(`/help/manual_expenditures/`, {
      params,
      signal: controller?.signal,
    });
  },
  post: (data: any) => {
    return axios.post<IHandBook>(`/help/manual_expenditures/`, data);
  },
  patch: (id: number, data: any) => {
    return axios.patch<IHandBook>(`/help/manual_expenditures/${id}/`, data);
  },
  delete: (id: number) => {
    return axios.delete(`/help/manual_expenditures/${id}/`);
  },
  approveExpenditures: (approvals: IHandBookExpenditureApproval) => {
    return axios.post(`/help/manual_expenditures/approve/`, approvals);
  },
  createTemplate: (data: any) => {
    return axios.post(`/help/templates/`, data);
  },
  getTemplatesList: (params: any) => {
    return axios.get<IListResponseData<IHandBookTemplate>>(`/help/templates/`, {
      params: { ordering: "created_at", ...params },
    });
  },
  patchTemplate: (id: number | string, data: any) => {
    return axios.patch(`/help/templates/${id}/`, data);
  },
  deleteTemplate: (id: number | string) => {
    return axios.delete(`/help/templates/${id}/`);
  },
  /** Одобрить текущий шаг согласования для пользователя */
  approveTemplate: ({ id, comment }: { id: number | string; comment?: string }) => {
    return axios.post(`/help/templates/${id}/approve/`, { comment });
  },
  /** Отклонить текущий шаг согласования для пользователя */
  rejectTemplate: ({ id, comment }: { id: number | string; comment?: string }) => {
    return axios.post(`/help/templates/${id}/reject/`, { comment });
  },
  /** Применить шаблон к объекту */
  sendTemplate: ({ id, buildingId }: { id: number | string; buildingId: number | string }) => {
    return axios.post(`/help/templates/${id}/send/`, { building: buildingId });
  },
  createTemplateSection: (data: ICreateTemplateSection) => {
    return axios.post(`/help/templates/sections/`, data);
  },
  cloneTemplateSections: ({ templateId, ids }: { templateId: string; ids: Array<{ section_id: number }> }) => {
    return axios.post(`/help/templates/${templateId}/sections/copy/`, ids);
  },
  cloneTemplateSubSections: ({
    templateId,
    ids,
  }: {
    templateId: string;
    ids: Array<{ subsection_id: number; parent_id: number }>;
  }) => {
    return axios.post(`/help/templates/${templateId}/subsections/copy/`, ids);
  },
  getTemplateSectionsList: (params: IGetTemplateSectionsListFilter) => {
    return axios.get(`/help/templates/sections/`, { params: { ordering: "created_at", ...params } });
  },
  deleteTemplateSection: (id: number | string) => {
    return axios.delete(`/help/templates/sections/${id}/`);
  },
  patchTemplateSection: (id: number | string, data: Partial<ICreateTemplateSection>) => {
    return axios.patch(`/help/templates/sections/${id}/`, data);
  },
  getTemplateExpendituresList: (params: any) => {
    return axios.get<IListResponseData<IHandBookTemplateExpenditure>>(`/help/templates/expenditures/`, {
      params: { ordering: "created_at", ...params },
    });
  },
  createTemplateExpenditure: (data: ICreateTemplateExpenditure) => {
    return axios.post(`/help/templates/expenditures/`, data);
  },
  deleteTemplateExpenditure: (id: number) => {
    return axios.delete(`/help/templates/expenditures/${id}/`);
  },
  patchTemplateExpenditure: (id: number | string, data: Partial<ICreateTemplateExpenditure>) => {
    return axios.patch(`/help/templates/expenditures/${id}/`, data);
  },
  getSegments: () => {
    // Позапрашиваем только родительские сегменты, т.к. дочерние вложены в поле children
    return getLongList(axios.get<IHandBookSegment[]>(`/help/segments/`, { params: { limit: 500, parent_isnull: 1 } }));
  },
};
